module.exports = __webpack_public_path__ + "static/media/work (5).b73559a1.jpg";